<script>
  // This component hold the legend visible in the map
  import { COUNTRIES } from '../stores.js';
  import { onMount, afterUpdate } from 'svelte';
  import { VALUES } from '../config.js';
  import tooltip from '../scripts/tooltip.js';
  import { watchResize } from 'svelte-watch-resize';
  import { scaleLinear, scaleBand } from 'd3-scale';
  import compact from 'lodash/compact'
  import filter from 'lodash/filter'
  import forEach from 'lodash/forEach'
  import get from 'lodash/get'
  import map from 'lodash/map'
  import values from 'lodash/values'
  import keys from 'lodash/keys'
  import countBy from 'lodash/countBy'

  let width = 0;
  let height = 0;

  const margin = {
    top: 0,
    right: 10,
    left: 5,
    bottom: 35
  }

  let countries;
  COUNTRIES.subscribe(value => { countries = value; });

  $: viewBox = `0 0 ${width} ${height}`

  $: style = `max-height: ${keys(VALUES).length * 2}rem`

  $: datum = countBy(countries.filter(country => keys(VALUES).includes(country.status)), 'status')

  $: baseX = width / 2

  $: yScale = scaleBand()
    .domain(keys(VALUES))
    .rangeRound([margin.top, height - margin.bottom])
    .padding(0.3)

  $: xScale = scaleLinear()
    .domain([0, Math.max(...values(datum))])
    .range([0, width / 2 - margin.right])

  $: barHeight = yScale.bandwidth()

  $: elements = map(datum, (count, key) => {
    const text = `In ${count === 1 ? 'einem Land' : `${count} Ländern`} sind sozialdemokratischer und sozialistischer Parteien als ${key} an der Regierung beteiligt.`
    const tooltip = { content: text, followCursor: false }
    return {
      x: baseX,
      width: xScale(count),
      height: barHeight,
      y: yScale(key),
      color: VALUES[key],
      label: key,
      tooltip
    }
  })

  function getTicks (xScale, yScale, baseX) {
    const [y1, y2] = yScale.range()
    return compact(map(xScale.ticks(2), tick => {
      if (tick === 0) return false
      return {
        x: xScale(tick) + baseX,
        y1,
        y2,
        label: tick
      }
    }))
  }

  $: ticks = getTicks(xScale, yScale, baseX)

  function getBase (scale) {
    const [y1, y2] = scale.range()

    return {
      y1,
      y2,
      x: baseX
    }
  }

  // Base is the baseline of the chart
  $: base = getBase(yScale)

  function resizeLegend (node) {
    ({ width, height } = node.getBoundingClientRect());
  }
</script>

<div class="page-legend" use:watchResize={resizeLegend} role="contentinfo" style={style}>
  <svg class="vis" {viewBox} preserveAspectRatio="xMinYMin meet">
    <g>
      {#each ticks as tick}
      <g>
        <text class="tick" x={tick.x} y={tick.y2 + 4} text-anchor="middle" dominant-baseline="hanging">{ tick.label }</text>
        <line class="tick" x1={tick.x} x2={tick.x} y1={tick.y1} y2={tick.y2} />
      </g>
      {/each}
      {#each elements as type}
      <g>
        <text
          x={type.x - 10}
          y={type.y + type.height / 2}
          text-anchor="end"
          dominant-baseline="middle"
          class="label">
          { type.label }
        </text>
        <rect
          x={type.x}
          y={type.y}
          height={type.height}
          width={type.width}
          fill={type.color}
          use:tooltip={type.tooltip} />
      </g>
      {/each}
      <line x1={base.x} x2={base.x} y1={base.y1} y2={base.y2} />
    </g>
  </svg>
</div>
